import { Circ, Expo, TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import { Button } from "../gameobjects/Button";

import { random, shuffle } from "html-living-framework/lib/Utils/ArrayUtils";
import { sendToFront } from "html-living-framework/lib/Utils/PixiUtils";
import { Application } from "../Application";
import * as VO from "../data/VO";
import { CaptionManager } from "../managers/CaptionManager";
import { AbstractBadgePopup } from "./AbstractBadgePopup";

export class TrashBadgePopup extends AbstractBadgePopup {

    public static readonly NAME = "TrashBadgePopup";
    public readonly badgeVO = [VO.BADGE02, VO.BADGE02B];

    public init(pSize: PIXI.Point) {
        super.init(pSize);
        this.oscar.visible = true;
    }

    public AnimateIn(pCallback: () => void) {
        super.AnimateIn(pCallback);
        shuffle(AbstractBadgePopup.stickers.trash);
        const nextSticker: number | undefined = AbstractBadgePopup.stickers.trash.pop();
        AbstractBadgePopup.latestSticker.trash = nextSticker;
        if (nextSticker !== undefined) {
            this.trashSticker[nextSticker].visible = true;
            sendToFront(this.trashSticker[nextSticker]);
            TweenLite.from(this.trashSticker[nextSticker], 0.5, {pixi: {scale: 1.5, alpha: 0}});
        }
    }
}
